module.exports = __webpack_public_path__ + "static/media/med.e42c70d3.svg";